/*  Shared  */
import { LastUpdatedCard } from 'application/Shared/Components/Cards/Components/LastUpdatedCard';
import { Route } from 'application/Shared/Helpers';
import { formatDistanceToNow } from 'application/Shared/Helpers/Dates';

/* Hooks */
import { useFetchApplicationAccounts } from 'hooks/dataAccess/User/userApplicationAccounts';

/*  React  */
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const getLastDiscoveredDate = (accounts) => {
    // Descending order
    const sortedAccountsByDate = accounts.sort((a, b) => {
        if (a.firstUsed > b.firstUsed) return -1;
        if (a.firstUsed < b.firstUsed) return 1;
        return 0;
    });

    return sortedAccountsByDate[0]?.firstUsed;
};

export const UserTotalAccountsCard = () => {
    const { t } = useTranslation();
    const { clientId, userId, partnerId } = useParams();

    const params = useMemo(
        () => ({
            compactUsernames: true,
            includeTotalLogins: true,
            platformTenantId: clientId,
            platformUserId: userId,
            size: -1
        }),
        [clientId, userId]
    );

    const { accounts } = useFetchApplicationAccounts({
        clientId,
        params
    });

    const lastAccountDiscoveredDate = getLastDiscoveredDate(accounts);

    const route = Route.buildBaseAdminRoute({ clientId, partnerId });

    return (
        <LastUpdatedCard
            content={accounts.length || '-'}
            buttonText={t('UserDashboard.viewAccounts')}
            lastUpdated={
                <Trans
                    i18nKey="UserDashboard.lastAccountAdded"
                    components={{
                        Date: lastAccountDiscoveredDate ? (
                            <>
                                {formatDistanceToNow(lastAccountDiscoveredDate)}
                            </>
                        ) : (
                            <>-</>
                        )
                    }}
                />
            }
            route={`${route}/accounts`}
            title={t('Common.totalAccounts')}
        />
    );
};
